import { useSyncExternalStore } from "react";

const subscribe = (onStoreChange: () => void): (() => void) => {
  document.addEventListener("visibilitychange", onStoreChange);
  return () => {
    document.removeEventListener("visibilitychange", onStoreChange);
  };
};

const getSnapshot = (): boolean => document.visibilityState === "visible";

/**
 * Exposes the document.visibilityState in hook form. https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilityState
 * @returns whether the document is visible
 */
export const usePageVisibility = (): boolean =>
  useSyncExternalStore(subscribe, getSnapshot, () => true);
